module.exports = __webpack_public_path__ + "static/media/black-kitty-before-after.a59119f7.jpg";